import Link from "next/link";
import Image from "next/image";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Add from "@mui/icons-material/Add";
import Close from "@mui/icons-material/Close";
import Remove from "@mui/icons-material/Remove";
import { FlexBox } from '@/components/flex-box';
import { currency } from "lib";
import { CircularProgress } from "@mui/material";


export default function MiniCartItem({
  item,
  handleCartAmountChange,
  onDelete,
  loading
}) {
  return <FlexBox py={2} px={2.5} key={item.id} alignItems="center" borderBottom="1px dashed" borderColor="divider" gap={2}>
    <Link prefetch={false} href={`/products/${item.id}`}>
      <Avatar variant="rounded" sx={{
        width: 75,
        height: 75,
        borderRadius: 3
      }}>


        <Image alt={item.name} src={item.photo} fill sizes="(75px, 75px)" />
      </Avatar>
    </Link>

    <Box flex="1" textOverflow="ellipsis" whiteSpace="nowrap" overflow="hidden">
      <Typography noWrap variant="h7" >
        {item.name}
      </Typography>

      <Typography variant="body1" sx={{
        fontSize: 14,
        color: "grey.600",
        mb: 1
      }}>
        {currency(item.price)} x {item.qty}
      </Typography>

      {loading ? <Box display="flex" alignItems="center" gap={1}>
        <CircularProgress size={24} />
        <Typography variant="body2" color="text.secondary">
          {loading ? "Actualizando..." : ""}
        </Typography>
      </Box>
        : <FlexBox alignItems="center" gap={1}>

          <Button size="small" color="primary" variant="outlined" disabled={item.qty === 1} onClick={handleCartAmountChange(-1, item)} sx={{
            height: 24,
            width: 24,
            borderRadius: 1.5
          }}>
            <Remove fontSize="small" />
          </Button>
          <Typography variant="h6" sx={{
            mx: "3px"
          }}>
            {item.qty}
          </Typography>

          <Button size="small" color="primary" variant="outlined" onClick={handleCartAmountChange(1, item)} sx={{
            height: 24,
            width: 24,
            borderRadius: 1.5
          }}>
            <Add fontSize="small" />
          </Button>

        </FlexBox>}
    </Box>

    {!loading && (
      <IconButton size="small" onClick={onDelete(item)}>
        <Close fontSize="small" />
      </IconButton>
    )}
  </FlexBox>;
}